// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"655":"b89cd089","867":"b54dda00"}[chunkId] + ".chunk.js";
};